import loadable from '@loadable/component'

const routers = [
  {
    path: '',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '../pages/404')
    ),
  },
]

export const getRouter = (_routers) => {
  return [..._routers, ...routers]
}
